
function requestFile(importFileJS) {
  return importFileJS
      .then((obj) => {
          console.log("requestFile");
          return JSON.parse(JSON.stringify(obj.default));
      })
      .then((response) => {
          console.log("requestFile response: ", response);
          return response;
      });
}

const steps = {
  "undefined": "PhoneEmailStep",
  init: "PhoneEmailStep",
  CpaClickStep: "PhoneEmailStep",
  PhoneEmailStep: "AccountStep",
  AccountStep: "CpaRegistrationStep",
  CpaRegistrationStep: "SendConfirmationStep",
  SendConfirmationStep: "CheckConfirmationStep",
  CheckConfirmationStep: "CardDataStep",
  CardDataStep: "RegisterStep",
  RegisterStep: "Init3dsStep",
  Init3dsStep: "ThreeDsStep"
};

export default {
  init() {
    return requestFile(import("./step.stub.js")).then((obj) => {
      obj.step = steps["init"];
      return obj;
    });
  },
  step(params){
    return requestFile(import("./step.stub.js")).then((obj) => {
      obj.step = steps[params.step]
      console.log("step : ", obj);
      return obj;
    });
  },
  show(params){
    return this.step(params);
  },
  back(params) {
    const stepsBack = Object.keys(steps).reduce((acc, stepKey) => {
      let nextStep = stepKey;

      if(nextStep === "SendConfirmationStep"){
         nextStep = "AccountStep"
      }

      if(nextStep === "Init3dsStep"){
        nextStep = "CardDataStep";
      }

      acc[steps[stepKey]] = nextStep;
      return acc;
    }, {});

    return requestFile(import("./step.stub.js")).then((obj) => {
      obj.step = stepsBack[params.step]
      console.log("back : ", obj);
      return obj;
    });
  }
};
